/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Purchase_Order_Not_EditableInputs */

const en_error_purchase_order_not_editable = /** @type {(inputs: Error_Purchase_Order_Not_EditableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This purchase order cannot be changed in its current status: send it back to rework first.`)
};

/**
* | output |
* | --- |
* | "This purchase order cannot be changed in its current status: send it back to rework first." |
*
* @param {Error_Purchase_Order_Not_EditableInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_purchase_order_not_editable = /** @type {((inputs?: Error_Purchase_Order_Not_EditableInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Purchase_Order_Not_EditableInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_purchase_order_not_editable(inputs)
});